import type { IUseCase } from '@/shared/contracts/use-case.contract';
import { HttpMethod, type IHttpClient } from '@/shared/contracts/http-client.contract';

import { CLUB_ENDPOINT, type ClubCatalog, type ClubSlugRequest } from '../types/club';

export class GetClubCatalogUseCase implements IUseCase<ClubSlugRequest, ClubCatalog> {
  private client: IHttpClient;

  constructor(client: IHttpClient) {
    this.client = client;
  }

  async execute({ slug }: ClubSlugRequest): Promise<ClubCatalog> {
    if (!slug) throw new Error('Slug is required');

    return this.client.sendRequest<ClubCatalog, never>({
      method: HttpMethod.GET,
      endpoint: `${CLUB_ENDPOINT(slug)}/catalog`,
    });
  }
}
